import step from "./endpoints/step";

export default {step}